import * as constants from './constants';

export function fetchFeedback(status) {
  return {
    type: constants.FETCH_FEEDBACK,
    payload: status
  };
}
export function fetchFeedbackDone(feedback) {
  return {
    type: constants.FETCH_FEEDBACK_DONE,
    payload: feedback
  };
}
export function fetchFeedbackFail(error) {
  return {
    type: constants.FETCH_FEEDBACK_FAIL,
    payload: error
  };
}

export function highlightFeedback(status) {
  return {
    type: constants.HIGHLIGHT_FEEDBACK,
    payload: status
  };
}
export function highlightFeedbackDone(feedback) {
  return {
    type: constants.HIGHLIGHT_FEEDBACK_DONE,
    payload: feedback
  };
}
export function highlightFeedbackFail(error) {
  return {
    type: constants.HIGHLIGHT_FEEDBACK_FAIL,
    payload: error
  };
}

export function deleteFeedback(status) {
  return {
    type: constants.DELETE_FEEDBACK,
    payload: status
  };
}
export function deleteFeedbackDone(feedback) {
  return {
    type: constants.DELETE_FEEDBACK_DONE,
    payload: feedback
  };
}
export function deleteFeedbackFail(error) {
  return {
    type: constants.DELETE_FEEDBACK_FAIL,
    payload: error
  };
}

export function fetchFeedbackCount() {
  return {
    type: constants.FETCH_FEEDBACK_COUNT
    //payload: status
  };
}
export function fetchFeedbackCountDone(feedback) {
  return {
    type: constants.FETCH_FEEDBACK_COUNT_DONE,
    payload: feedback
  };
}
export function fetchFeedbackCountFail(error) {
  return {
    type: constants.FETCH_FEEDBACK_COUNT_FAIL,
    payload: error
  };
}
